export class DateComponent {
    year: String;
    month: String;
    day: String;
}